import type { JSX } from 'react';
import { useEditor } from '../state/store.js';
import { TOOL_META } from '../state/tools.js';
import { useVolatile } from '../state/volatile.js';

export function StatusBar(): JSX.Element {
  const tool = useEditor((state) => state.tool);
  const status = useEditor((state) => state.status);
  const announcement = useEditor((state) => state.announcement);
  const readout = useVolatile();
  const meta = TOOL_META[tool];
  return (
    <footer className="status">
      <span className="mode" style={{ background: meta.badge }}>
        {meta.label}
      </span>
      <span className="msg">{status}</span>
      {/* Announcing all 52 status paths meant a spoken sentence per brick.
          The visible line still updates; only outcomes are read out (F22). */}
      <span role="status" aria-live="polite" className="visually-hidden">
        {announcement}
      </span>
      {readout.snapRelation !== null && <span className="coord">snap: {readout.snapRelation}</span>}
      <span className="coord">{readout.coordinate}</span>
    </footer>
  );
}
